import { ConyugeModel } from "./afiliaciones/conyuge.model";
import { Titular } from "./afiliaciones/titular.model";
import { Empresa } from "./afiliaciones/empresa.model";
import { SolicitudTiposEnum } from "./afiliaciones/solicitud-tipos.enum";
import { Solicitud } from "./solicitud.model";
import { Beneficiario } from "./afiliaciones/beneficiario.model";
import {TipoCECEnum} from '../enum/TipoCECEnum';

export class SolicitudCambioEstadoCivil {
  public version: string;
  public empresa: Empresa;
  public titular: Titular;
  public conyuge: ConyugeModel;
  public beneficiarios: Beneficiario[];
  public solicitud: Solicitud;

  static instance() {
    return new this();
  }

  static mapearDesdeFormularioCEC(
    formAfiliadoModel: object,
    formConyugeModel: any,
    formEmpresaModel: any,
  ) {
    const VERSION_CONTRATO = "1.0";
    const solicitudTipo = SolicitudTiposEnum.CEC;
    const afiliacionDto = SolicitudCambioEstadoCivil.instance();
    afiliacionDto.beneficiarios = [];
    afiliacionDto.version = VERSION_CONTRATO;
    afiliacionDto.titular = Titular.mapearDesdeFormularioCECASolicitud(formAfiliadoModel);
    afiliacionDto.solicitud = Solicitud.mapearDesdeFormularioAFT(solicitudTipo, formAfiliadoModel);
    afiliacionDto.conyuge = formConyugeModel;
    afiliacionDto.empresa = formEmpresaModel;
    return afiliacionDto;
  }
}
